import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFormFieldLayout } from 'components/FormField';
import FormStack from 'components/FormStack';
import { TitleCardWithToggle } from 'components/TitleCard';
import UrlField from 'components/FormFields/UrlField';
import Button from 'components/Button';
import EditLinkModal from 'screens/EditLinkModal';
import getEmbeddedVideo from 'utils/getEmbeddedVideo';
function LinkDetailsCard(_ref) {
  var isDistributed = _ref.isDistributed,
    fields = _ref.fields;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showEditLinkModal = _useState2[0],
    setShowEditLinkModal = _useState2[1];
  var customType = fields.customType,
    webUrl = fields.webUrl;
  var updateWebUrl = function updateWebUrl(url) {
    // Check customtype of the new URL and update it, if it changed
    var newUrlCustomType = getEmbeddedVideo(url) ? 'video' : 'web';
    if (customType.value !== newUrlCustomType) {
      customType.set(newUrlCustomType);
    }
    webUrl.set(url);
    setShowEditLinkModal(false);
  };
  return /*#__PURE__*/React.createElement(TitleCardWithToggle, {
    variant: "raised",
    title: t('content_type_link_details'),
    sideContent: /*#__PURE__*/React.createElement(Button, {
      icon: "edit",
      size: "medium",
      onClick: function onClick() {
        return setShowEditLinkModal(true);
      },
      isDisabled: isDistributed
    }, t('actions_edit_link'))
  }, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: true
  }, /*#__PURE__*/React.createElement(FormStack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(UrlField, {
    bold: false,
    fields: fields
  }))), showEditLinkModal && /*#__PURE__*/React.createElement(EditLinkModal, {
    onClose: function onClose() {
      return setShowEditLinkModal(false);
    },
    onSubmit: updateWebUrl,
    defaultValue: webUrl.value
  }));
}
export default LinkDetailsCard;